import { ArrowLeft, Lock } from "lucide-react";
import { Button } from "@/components/ui/button";
import { createFileRoute, useRouter } from "@tanstack/react-router";
import { redirectToLogin } from "@/hooks/services/workchestra/handler/auth";

export const Route = createFileRoute("/unauthorized")({
  component: RouteComponent,
});

function RouteComponent({
  title = "Access Restricted",
  description = "Please sign in to access this page and continue using the application.",
  loginLinkText = "Sign In",
}) {
  const router = useRouter();
  return (
    <div className="aero:flex aero:min-h-screen aero:w-full aero:flex-col aero:items-center aero:justify-center aero:bg-brand-primary/5 aero:p-4 aero:text-center">
      <div className="aero:mx-auto aero:mb-6 aero:flex aero:h-24 aero:w-24 aero:items-center aero:justify-center aero:rounded-full aero:bg-brand-primary/10">
        <Lock className="aero:h-12 aero:w-12 aero:text-brand-primary" />
      </div>

      <h1 className="aero:mb-2 aero:text-3xl aero:font-bold aero:tracking-tight">
        {title}
      </h1>
      <p className="aero:mb-8 aero:max-w-md aero:text-muted-foreground">
        {description}
      </p>

      <div className="aero:mb-8 aero:max-w-md aero:rounded-lg aero:border aero:bg-card aero:p-6 aero:shadow-sm">
        <div className="aero:space-y-3 aero:text-left aero:text-sm aero:text-muted-foreground">
          <p className="aero:font-medium">What you can do:</p>
          <ul className="aero:list-inside aero:list-disc aero:space-y-2 aero:pl-4">
            <li>Sign in with your existing account</li>
            <li>Create a new account if you don't have one</li>
            <li>Reset your password if you've forgotten it</li>
          </ul>
        </div>
      </div>

      <div className="aero:flex aero:flex-col aero:gap-3 aero:sm:flex-row">
        {router.history.length > 0 && (
          <Button
            intent="secondary"
            design="outline"
            size="lg"
            className="aero:min-w-[200px]"
            onClick={() => router.history.back()}
          >
            <ArrowLeft className="mr-2 h-4 w-4" />
            Go Back
          </Button>
        )}

        <Button
          intent="primary"
          design="solid"
          onClick={redirectToLogin}
          size="lg"
          className="aero:min-w-[200px]"
        >
          {/* <Link to={loginLink}> */}
          <Lock className="aero:mr-2 aero:h-4 aero:w-4" />
          {loginLinkText}
          {/* </Link> */}
        </Button>
      </div>
    </div>
  );
}
